import TextInput from "@/components/Ui/TextInput";
import VendorCard from "@/components/VendorSelect/VendorCard";
import { Vendor, useVendorContext } from "@/contexts/vendor-context";
import { useState } from "react";
import { twMerge } from "tailwind-merge";

const filterVendors = (vendors: Vendor[], text: string) =>
  text
    ? vendors.filter(
        ({ vendorId, name }) =>
          vendorId.includes(text.toLocaleLowerCase()) ||
          (name || "").toLocaleLowerCase().includes(text.toLocaleLowerCase()),
      )
    : vendors;

const VendorCardList = () => {
  const { vendors = [], getVendorSettings } = useVendorContext();
  const [textFilter, setTextFilter] = useState("");

  const vendorsWithSettings = vendors
    .map(getVendorSettings)
    .filter((vendor) => vendor) as Vendor[];
  const filteredVendors = filterVendors(vendorsWithSettings, textFilter);
  const showFilter = vendors.length > 10;

  return (
    <>
      {showFilter && (
        <div className="mb-2">
          <TextInput
            name="vendor-filter"
            autoFocus
            tabIndex={0}
            onChange={({ target: { value } }) => setTextFilter(value)}
            placeholder="Type to filter"
          />
        </div>
      )}
      <div
        className={twMerge(
          "custom-scrollbar custom-inline-scrollbar -mx-14 h-72 space-y-2 md:h-80",
          (filteredVendors.length > 4 || showFilter) &&
            "column-up overflow-y-scroll pr-[calc(theme(space.14)-15px)] pl-14",
          filteredVendors.length <= 4 &&
            !showFilter &&
            "column overflow-y-visible px-14",
        )}
      >
        {filteredVendors.map((vendor) => (
          <VendorCard vendor={vendor} key={vendor.vendorId} />
        ))}
        {filteredVendors.length === 0 && (
          <span className="text-muted-foreground">
            No vendor with that filter
          </span>
        )}
      </div>
    </>
  );
};

export default VendorCardList;
